// It is important not to include this in the index.ts file, because we share
// this file with the E2E Playwright tests, and it could cause problems with the
// fact that including it on index.ts causes a lot more code to be loaded into
// Playwright, which would make the tests fail.

export const logout = '/Identity/User/RevokeToken'

// USER
export const getUserData = 'Merchant/Merchant/Data'
export const changePassword = 'Identity/UserMerchant/ChangePassword'
export const changeEmail = 'Identity/UserMerchant/UpdateEmail'
export const deleteAccount = 'Identity/UserMerchant/Delete'

// DOWNLOADER
export const downloadLegalDocument = 'Merchant/Documents/GetLegalDocument'
export const downloadPublicDocumentByLanguage = '/Merchant/Anonymous/OpenDocumentsByLanguage'

// SIMULATOR
export const getSimulatorData = '/User/ProductSavingsSimulation'
export const calculateSimulatorData = '/User/ProductSavingsSimulation/Simulation'

// PRODUCTS
export const getProductData = '/User/Products'
export const getContractedProducts = '/User/Contract/Products'
export const contractProduct = '/User/Contract/Products/{productType}'
export const getKindergartens = '/User/Products/Kidergarten'
export const getInsurancesData = '/User/Products/HealthAssurance'

// ONBOARDING
export const getOnboardingData = '/User/OnboardingData'
export const getUnauthenticatedOnboardingData =
  '/User/Login/UnauthenticatedOnboardingData'
export const saveOnboardingData = '/User/LinkToEmployee'
export const saveUnauthenticatedOnboardingData = '/User/Login/CreateAndLinkToEmployee'

// HELPER
export const getHelperData = '/User/FAQs'
export const saveHelperFormData = '/User/Contact'

// INVOICES
export const getInvoiceData = 'Merchant/MerchantInvoice/SearchV2'
export const downloadInvoice = 'Merchant/MerchantInvoice/Download'
export const downloadRestaurantTransaction =
  'Merchant/MerchantInvoice/Transactions/Restaurant/Excel'
export const downloadGuarderiaTransaction =
  'Merchant/MerchantInvoice/Transactions/Kindergarten/Excel'

// TRANSACTIONS
export const getTransactionData = 'Merchant/Transaction/SearchV2'
export const getTransactionGuarderia = 'Merchant/Transaction/Kindergarten/SearchV2'
export const downloadTransactionSearch = 'Merchant/Transaction/ExcelV2'
export const downloadTransactionSearchGuarderia = 'Merchant/Transaction/Kindergarten/ExcelV2'
export const getFilterValues = 'Merchant/Transaction/FilterValues'

//FILTERS DATA
export const getTransactionLocalsFilter = 'Merchant/Merchant/AllowedAccessMerchantsForFilters'

// STORES
export const getRestaurantData = 'Merchant/Store/Restaurant'
export const getRestaurantFoodType = 'Merchant/MerchantCoockType/CoockTypes'
export const getContactsData = 'Merchant/Contacts/Data'
export const orderStickers = 'Merchant/Material/Order/Stickers'
export const kindergartenData = 'Merchant/Store/Kindergarten'

// TPVS
export const getTpvsData = 'Merchant/MerchantTerminal/Terminals'
export const addNewTpv = 'Merchant/MerchantTerminal/Add'

// ACCOUNT
export const getBankAccountData = 'Merchant/BancAccount/Data'
export const getSepaDocument = 'Merchant/BancAccount/InitUpdate'
export const acceptSepaDocument = 'Merchant/BancAccount/ConfirmUpdate'
export const getSignStatus = 'Merchant/BancAccount/VerifyEnding'

// CONTRACT
export const getContractData = 'Merchant/Billing/Data'
export const getProductConditions = 'Merchant/GeneralConditions/Data'
export const getAccountingStatus = 'Merchant/Accounting/AccountingStatus'
export const processUnpaidInvoices = 'Merchant/Accounting/CollectUnpaidInvoices'
export const getProductContract = 'Merchant/Documents/ProductContract'

// SIGN UP
export const login = 'Identity/Anonymous/Merchant/LoginValidation'
export const signUp = 'Identity/UserMerchant/AutoEnrollment'
export const validateOtpCode = 'Identity/OTP/Validation'
export const resendOtpCode = 'Identity/OTP/ResendOTP'
export const passwordRecovery = 'Identity/Anonymous/Merchant/PasswordRecovery'
export const passwordRecoveryEmailResend = 'Identity/Anonymous/Merchant/PasswordRecoveryRetry'
export const updatePassword = 'Identity/Anonymous/UpdatePassword'
export const verifyUpdatePasswordToken = '/Identity/Anonymous/ValidateUpdatePasswordToken'
export const createAccount = 'Identity/Anonymous/Merchant/AccountCreation/Register'
export const validateToken = '/Identity/Anonymous/Merchant/AccountCreation/ValidateToken?token='
export const validateTokenAndGetMerchantData = '/Identity/Anonymous/Merchant/AccountCreation/GetMerchantData?token='
export const registerVerifyIdentity = '/Identity/Anonymous/Merchant/AccountCreation/Identify'
export const registerEmailResend = 'Identity/Anonymous/Merchant/AccountCreation/RetryIdentify'

// AUTO ENROLLMENT
export const checkCifAlreadyExists = 'Merchant/Merchant/CheckLegalIdAlreadyInUse'
export const getAutoEnrollmentData = 'Merchant/AutoEnrollment/NewUser/Context'
export const getAutoEnrollmentProductData = 'Merchant/AutoEnrollment/NewProduct/Context'
export const saveAutoEnrollmentFinantialData =
  'Merchant/AutoEnrollment/NewUser/FinantialData'
export const saveAutoEnrollmentStoreData = 'Merchant/AutoEnrollment/NewUser/StoreData'
export const getAutoEnrollmentDefaultConditions =
  'Merchant/AutoEnrollment/DefaultConditions'
export const getAutoEnrollmentDocuments = 'Merchant/AutoEnrollment/DocumentsForSigning'
export const saveAutoEnrollmentProducts = 'Merchant/AutoEnrollment/BeginDocumentsSigning'
export const getAutoEnrollmentLogaltyStatus =
  'Merchant/AutoEnrollment/VerifySigningEnding'
export const saveAutoEnrollmentOwnerData =
  'Merchant/AutoEnrollment/NewProduct/UpdatePropietaryContact'

// Cashback AutoEnrollment
export const getCashbackAutoEnrollmentStartTransaction =
  'Merchant/AutoEnrollment/Cashback/StartTransaction'

// ACCESS ROLES
export const getAccessRolesData = 'Merchant/Merchant/UsersWithRolAssignment'  
  
  // MISCELLANEOUS
  
export const checkBlockedEndpoint = 'Identity/Anonymous/CheckEndpointRateLimit'

export const multiWeb = 'Merchant/Merchant/AllowedAccessMerchants'
export const setActiveMultiWeb = 'Merchant/Merchant/SetActiveMerchant'
export const createProfile = 'Merchant/Merchant/CreateUserWithRoleAssignment'
export const updateProfile = 'Merchant/Merchant/UpdateUserRoleAssignment'
export const deleteProfile = 'Merchant/Merchant/DeleteUserWithRoleAssignment'
export const getPermissions = 'Merchant/Merchant/WebTagsPermissions'

// HELP CENTER
export const getHelpCenterCaseReasons = 'Merchant/HelpCenter/CaseReasons'
export const getHelpCenterCaseProducts = 'Merchant/HelpCenter/CaseProducts'
export const saveHelpCenterCase = 'Merchant/HelpCenter/CaseSupportRequest'